// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"436":"successfulCase","443":"about","679":"intellectualproperty"}[chunkId] + "." + {"436":"3fb1df1a","443":"e9fe72c8","679":"ea05ec49"}[chunkId] + ".css";
};